module.exports = __webpack_public_path__ + "images/assets/371e3cdf280e166ec7e1eab58fd308d2.svg";